import { KeyValue } from "@/main/models/common";
import { PredefinedSearchActionTypes, PredefinedSearchTypes } from "./predefinedSearchTypes";

export function getPredefinedSearch( 
 routeUrl: string 
): PredefinedSearchActionTypes {
  return { 
    type: PredefinedSearchTypes.GET_DOMAIN_PREDEFINED_SEARCH,
    payload: { routeUrl  } 
   };
}

export function savePredefinedSearch(
    data: KeyValue[] | null, 
    isError: boolean, 
    errorMessages: string[] | null
): PredefinedSearchActionTypes {
  return { 
    type: PredefinedSearchTypes.SAVE_DOMAIN_PREDEFINED_SEARCH, 
    payload: { data, isError, errorMessages } };
}

export function resetReducerPredefinedSearch(): PredefinedSearchActionTypes {
  return { type: PredefinedSearchTypes.RESET_REDUCER_PREDEFINED_SEARCH };
}